import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-hide"
export default class extends Controller {
  static values = { seconds: Number, message: String }

  connect() {
    if (this.hasMessageValue && this.messageValue.trim() !== "") {
      this.speakMessage()
    }

    if (!this.secondsValue || this.secondsValue <= 0) return

    this.timeout = setTimeout(() => {
      this.hide()
    }, this.secondsValue * 1000)
  }

  speakMessage() {
    if (!window.speechSynthesis) return

    window.speechSynthesis.cancel()

    setTimeout(() => {
      const utterance = new SpeechSynthesisUtterance(this.messageValue)
      utterance.lang = "en-US"
      utterance.rate = 1
      utterance.pitch = 1
      utterance.volume = 1
      window.speechSynthesis.speak(utterance)
    }, 100)
  }

  hide() {
    this.element.classList.add("opacity-0", "transition-opacity", "duration-300")
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
